import { Campaign } from "@product/rosetta-sdk";
import { useEffect } from "react";
import type { FunctionComponent } from "react";

export const RosettaCampaignPopup: FunctionComponent = () => {
  useEffect(() => {
    Campaign.Popup.showCampaignPopUp({
      tracking: {
        customized_parameters: {
          trigger_point: "homepage subscription popup",
        },
      },
    });
  }, []);
  return null;
};
